import orderBy from 'lodash/orderBy';
import { ApolloClient } from '@apollo/client';

import type { AnswerFragment } from '../../present/activity-answers.graphql.generated';
import type { GetClassStudentAnswersQuery } from '../../present/activity-answers.graphql.generated';
import { GET_CLASS_STUDENT_ANSWERS } from 'approot/activity-builder/present/activity-answers.graphql';
import { ActivitiesContentType } from 'global/constants';

export function updateClassAnswersInCache({
  client,
  updatedAnswer,
  userClassId,
  contentId,
  contentType,
  contentVersion,
}: {
  client: ApolloClient<any>;
  updatedAnswer: AnswerFragment;
  userClassId: number;
  contentId: number;
  contentType: ActivitiesContentType;
  contentVersion: string;
}) {
  const classId = userClassId;
  const answerData = client.cache.readQuery<GetClassStudentAnswersQuery>({
    query: GET_CLASS_STUDENT_ANSWERS,
    variables: {
      input: {
        classId,
        contentId,
        contentType,
        contentVersion,
      },
    },
  });

  const answersInCache = answerData?.getClassStudentsAnswers || [];
  const isExisting = answersInCache.find(a => a.uuid === updatedAnswer.uuid);

  client.cache.writeQuery<GetClassStudentAnswersQuery>({
    query: GET_CLASS_STUDENT_ANSWERS,
    data: {
      getClassStudentsAnswers: orderBy(
        isExisting
          ? answersInCache.map(answer => {
              if (answer.uuid === updatedAnswer.uuid) {
                return updatedAnswer;
              }
              return answer;
            })
          : [updatedAnswer, ...answersInCache],
        ['classId', 'createdAt'],
        ['desc']
      ),
    },
    variables: {
      input: {
        classId,
        contentId,
        contentType,
        contentVersion,
      },
    },
  });
}
